var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2108_23641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97921 2.1875C9.65891 2.1875 11.2698 2.85476 12.4576 4.04249C13.6453 5.23022 14.3125 6.84113 14.3125 8.52083C14.3125 10.2005 13.6453 11.8114 12.4576 12.9992C11.2698 14.1869 9.65891 14.8542 7.97921 14.8542C6.2995 14.8542 4.68859 14.1869 3.50086 12.9992C2.31313 11.8114 1.64587 10.2005 1.64587 8.52083C1.64587 6.84113 2.31313 5.23022 3.50086 4.04249C4.68859 2.85476 6.2995 2.1875 7.97921 2.1875Z",
    fill: "#525365"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97914 2.50768C6.3843 2.50768 4.85479 3.14122 3.72707 4.26894C2.59935 5.39666 1.96581 6.92617 1.96581 8.52101C1.96581 10.1158 2.59935 11.6454 3.72707 12.7731C4.85479 13.9008 6.3843 14.5343 7.97914 14.5343C9.57397 14.5343 11.1035 13.9008 12.2312 12.7731C13.3589 11.6454 13.9925 10.1158 13.9925 8.52101C13.9925 6.92617 13.3589 5.39666 12.2312 4.26894C11.1035 3.14122 9.57397 2.50768 7.97914 2.50768ZM3.27452 3.81639C4.52226 2.56865 6.21456 1.86768 7.97914 1.86768C9.74371 1.86768 11.436 2.56865 12.6838 3.81639C13.9315 5.06413 14.6325 6.75644 14.6325 8.52101C14.6325 10.2856 13.9315 11.9779 12.6838 13.2256C11.436 14.4734 9.74371 15.1743 7.97914 15.1743C6.21456 15.1743 4.52226 14.4734 3.27452 13.2256C2.02678 11.9779 1.32581 10.2856 1.32581 8.52101C1.32581 6.75644 2.02678 5.06413 3.27452 3.81639Z",
    fill: "#525365"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01331 7.47918C7.01331 7.30245 7.15657 7.15918 7.33331 7.15918H7.99997C8.1767 7.15918 8.31997 7.30245 8.31997 7.47918V11.3542C8.31997 11.5309 8.1767 11.6742 7.99997 11.6742C7.82324 11.6742 7.67997 11.5309 7.67997 11.3542V7.79918H7.33331C7.15657 7.79918 7.01331 7.65591 7.01331 7.47918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01331 11.4792C7.01331 11.3024 7.15657 11.1592 7.33331 11.1592H8.66664C8.84337 11.1592 8.98664 11.3024 8.98664 11.4792C8.98664 11.6559 8.84337 11.7992 8.66664 11.7992H7.33331C7.15657 11.7992 7.01331 11.6559 7.01331 11.4792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83339 5.79918C7.9641 5.79918 8.07005 5.69322 8.07005 5.56251C8.07005 5.43181 7.9641 5.32585 7.83339 5.32585C7.70268 5.32585 7.59672 5.43181 7.59672 5.56251C7.59672 5.69322 7.70268 5.79918 7.83339 5.79918ZM7.43005 5.56251C7.43005 5.33976 7.61063 5.15918 7.83339 5.15918C8.05614 5.15918 8.23672 5.33976 8.23672 5.56251C8.23672 5.78527 8.05614 5.96585 7.83339 5.96585C7.61063 5.96585 7.43005 5.78527 7.43005 5.56251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83334 5.97746C8.06253 5.97746 8.24834 5.79166 8.24834 5.56246C8.24834 5.33326 8.06253 5.14746 7.83334 5.14746C7.60414 5.14746 7.41833 5.33326 7.41833 5.56246C7.41833 5.79166 7.60414 5.97746 7.83334 5.97746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2108_23641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.053e89c58db03f25efcc396642a5800d.svg";
export { ForwardRef as ReactComponent };